function getDashboardCustomer(dashboard) {
  return dashboard?.report?.customer || dashboard?.page?.customer || null;
}

function getDashboardWebsites(customer) {
  return (customer?.dataSources || []).filter(ds => ds.website?.url).map(ds => ds.website);
}

module.exports = {
  getDashboardCustomer,
  getDashboardWebsites,
};
